import axiosInstance from "@/store/axios.instance";

export default {
    namespaced: true,
    state() {
        return{
            coordinaten: null,
        }
    },
    mutations: {
        setCoordinaten(state,coordinaten) {
            state.coordinaten = coordinaten
        }
    },
    actions: {
        async fetchCoordinaten({commit},date){
            await axiosInstance.get("/zon/coordinaten/centrum", {
                params: { date },
            }).then(result => commit('setCoordinaten',result.data))
        }
    }
}